export default "__VITE_ASSET__CnpWGyWn__"